// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"app-header_wrapper__ECTu6","logo":"app-header_logo__zVEfY"};